import Grid from './Grid'
import Stack from './Stack'
import { ILayoutProps } from './types.d'

export default function (props: ILayoutProps) {
    return props.config.layout === 'Grid' ? <Grid {...props} /> : <Stack {...props} />
}
